export interface WorkOrder {
  contractAmount: number;
  description: string;
  isBillable: boolean;
  phaseID: string;
  phaseName: string;
  po: string;
  poDate: string;
  totalCosts: number;
  isContractActive: boolean;
  jobID: string;
  /**
   * Viewpoint per-phase timesheet block (bJCJP.udTimesheetBlock, 'Y' = blocked). #30262.
   * Optional: an older API omits it. Read through `isWorkOrderTimesheetBlocked`
   * from `@ups/xplat/utils`, never raw comparison.
   */
  udTimesheetBlock?: string | null;

  // client
  value: string;
  text: string;
}
